export default __webpack_public_path__ + "static/americana-73b62915312449cf8c2d226915755a12.woff2";